import { render, h } from "preact";
import ModelViewer from "../components/ModelViewer.js";

const viewers = document.querySelectorAll("[data-model-viewer]");

viewers.forEach((container) => {
  const props = {
    src: container.dataset.src,
    classes: container.dataset.classes,
  };
  render(h(ModelViewer, props), container);
});
